import { combineReducers } from 'redux';

import stateData from './stateData/stateDataReducer';

export default combineReducers({
	stateData,
});
